// Utility functions for formatting values across the app

/**
 * Format a number as Mexican Peso currency
 * @param {number} value - The value to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value) => 
  new Intl.NumberFormat('es-MX', { 
    style: 'currency', 
    currency: 'MXN' 
  }).format(value || 0);

/**
 * Format a date in Mexican locale
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string or '-' if invalid
 */
// "YYYY-MM-DD" se interpreta como fecha LOCAL (new Date("YYYY-MM-DD") la toma como UTC
// y en zonas horarias negativas retrocede un día → los movimientos del día 1 caían en el mes anterior).
export const parseLocalDate = (date) => {
  if (date instanceof Date) return date;
  if (typeof date === 'string') {
    const m = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  return new Date(date);
};

export const formatDate = (date) => 
  date ? parseLocalDate(date).toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' }).replace('.', '') : '-';

// DD/MM/YYYY: solo para exportaciones CSV (Excel lo reconoce como fecha)
export const formatDateNumeric = (date) => 
  date ? parseLocalDate(date).toLocaleDateString('es-MX') : '-';

/**
 * Format a date with full month name
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDateLong = (date) => 
  date ? parseLocalDate(date).toLocaleDateString('es-MX', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  }) : '-';

/**
 * Format a number with thousands separator
 * @param {number} value - The value to format
 * @returns {string} Formatted number string
 */
export const formatNumber = (value) => 
  new Intl.NumberFormat('es-MX').format(value || 0);

/**
 * Format percentage
 * @param {number} value - The value to format (0-100)
 * @returns {string} Formatted percentage string
 */
export const formatPercent = (value) => 
  `${(value || 0).toFixed(1)}%`;

// Fecha de hoy según la zona horaria del workspace (YYYY-MM-DD)
export { todayLocal } from './clock';

// Etiqueta "Cubre: mes" para rentas cuyo periodo (period_month) difiere del mes de la fecha real del depósito
export const periodBadge = (t) => {
  const pm = t?.period_month; const dm = (t?.transaction_date || '').slice(0, 7);
  if (!pm || !dm || pm === dm) return null;
  const label = new Date(`${pm}-15`).toLocaleDateString('es-MX', { month: 'short', year: 'numeric' });
  return { label: `${pm > dm ? 'Anticipo' : 'Atraso'} · Cubre ${label}`, className: pm > dm ? 'text-sky-700 bg-sky-100' : 'text-amber-800 bg-amber-100' };
};
